import { VerifyEmailIcon } from "@assets";
import * as Sentry from "@sentry/browser";
import Image from "next/image";

const VerifyEmail = ({
  email,
  resend: resend = () => {},
}: {
  email: string;
  resend: () => void;
}) => {
  Sentry.addBreadcrumb({
    category: "sentEmailLink",
    level: "info",
  });
  Sentry.setTag("email", email);
  return (
    <div className="flex flex-col justify-center items-center text-center">
      <div className="w-12 svg-primary">
        <Image
          src={VerifyEmailIcon}
          layout="responsive"
          alt="Check your email"
        />
      </div>
      <h1 className="capitalize text-2xl m-8 font-bold">Check your email</h1>
      <p className="m-1 text-lg">
        We sent an <span className="text-primary font-bold"> one-time </span>{" "}
        sign in link to <em className="font-bold text-primary">{email}</em>.
      </p>
      <p className="m-1 text-lg">Please click the link to continue.</p>

      <h2 className="text-secondary mt-8">Did not receive the email?</h2>
      <p className="text-secondary">
        Also check your junk / spam inbox. Or
        <a
          className="text-primary underline mx-1 font-semibold"
          onClick={resend}
        >
          resend link
        </a>
        .
      </p>
    </div>
  );
};

export default VerifyEmail;
